import React, { useState, useEffect, useRef } from "react";
import { Button, ButtonGroup, Row, Col, Form, Modal } from "react-bootstrap";
import { IntlProvider, FormattedMessage } from "react-intl";
import enMessages from "./locales/en.json";
import arMessages from "./locales/ar.json";
import roMessages from "./locales/ro.json";
import SectionSeparator from "./components/SectionSeparator";
import SubSectionSeparator from "./components/SubSectionSeparator";
import { ToastContainer, toast } from "react-toastify";
import FilePicker from "./components/FilePicker";
import AdmissionSiblings from "./components/AdmissionSiblings";
import DatePicker from "react-datepicker";
import moment from "moment";
import ReCAPTCHA from "react-google-recaptcha";

var Chance = require("chance");
var chance = new Chance();

const App = () => {
  // Get query parameters
  const queryParameters = new URLSearchParams(window.location.search);
  const aid = queryParameters.get("aid");

  // Refs
  const recaptcha = useRef();

  const center_uuid = { 31: "a955fe21-402a-42f3-9f45-2b987565f075" };

  // Constants
  const version = "2.3";
  const API_URL = process.env.REACT_APP_API_URL;
  const PORTAL_URL = process.env.REACT_APP_PORTAL_URL;
  const messages = {
    en: enMessages,
    ar: arMessages,
    ro: roMessages,
  };
  const steps = [
    { name: "step.student_details", step: 1 },
    // { name: "step.visual_media_consent", step: 2 },
    // { name: "step.clinic_information", step: 3 },
    { name: "step.known_allergies", step: 2 },
    // { name: "step.question_answer", step: 5 },
    // { name: "step.required_documents", step: 6 },
    // { name: "step.terms_conditions", step: 5 },
  ];
  const errorsObj = {
    center_id: false,
    captcha: false,
    child_name: false,
    child_last_name: false,
    birth_date: false,
    birth_city: false,
    gender: false,
    country_id: false,
    religion: false,
    child_sen: false,
    id_number: false,
    father_name: false,
    father_mobile: false,
    father_email: false,
    father_country_id: false,
    father_employer: false,
    father_language: false,
    emergency_contact1: false,
    emergency_relation1: false,
    emergency_phone1: false,
    emergency_contact2: false,
    emergency_relation2: false,
    emergency_phone2: false,
    allergies: false,
  };

  // State
  const [locale, setLocale] = useState("en");
  const [signature, setSignature] = useState(null);

  const [countries, setCountries] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [ageGroup, setAgeGroup] = useState([]);
  const [centerLicData, setCenterLicData] = useState([]);
  const [classes, setClasses] = useState([]);
  const [errors, setErrors] = useState(errorsObj);
  const [step, setStep] = useState(1);
  const [stepName, setStepName] = useState("step.student_details");
  const [formSaving, setFormSaving] = useState(false);
  const [formData, setFormData] = useState({
    admission_id: 0,
    center_id: 31,
    // center_uuid: "",
    child_name: "",
    child_middle_name: "",
    child_last_name: "",
    birth_date: "",
    gender: "",
    country_id: "",
    religion: "",
    birth_city: "",
    agegroup_id: "",
    centerlic_id: "",
    sponsor_role: "Father",
    father_name: "",
    father_mobile: "",
    father_workphone: "",
    father_email: "",
    father_employer: "",
    father_position: "",
    father_income: "",
    father_language: "",
    father_country_id: "",
    father_passport_num: "",
    father_passport_validity: "",
    father_residency_number: "",
    father_residency_validity: "",
    spouse_role: "Mother",
    mother_name: "",
    mother_mobile: "",
    mother_workphone: "",
    mother_email: "",
    mother_employer: "",
    mother_position: "",
    mother_language: "",
    mother_income: "",
    mother_country_id: "",
    mother_education: "",
    mother_passport_num: "",
    mother_passport_validity: "",
    mother_residency_number: "",
    mother_residency_validity: "",
    admission_siblings: [],
    child_school_attending: "",
    emergency_contact1: "",
    emergency_relation1: "",
    emergency_phone1: "",
    emergency_contact2: "",
    emergency_relation2: "",
    emergency_phone2: "",
    nanny_name: "",
    nanny_phone: "",
    driver_name: "",
    driver_phone: "",
    sponsor_email: "",
    admissioncountries: [],
    first_lang: "",
    second_lang: "",
    third_lang: "",
    reading_prof: "",
    writing_prof: "",
    speaking_prof: "",
    bloodgroup: "",
    current_curr: "",
    child_sen: "",
    id_number: "",
    previous_enroll: "",
    residency_number: "",
    residency_validity: "",
    child_use_toilet: [],
    pic_nursery: 0,
    pic_media: 0,
    pic_social: 0,
    take_pictures: 1,
    leela_allergies: "No",
    leela_dietry_intolerances: "No",
    leela_special_req: "No",
    allergies: "",
    medicines: "",
    allergic_reactions: "",
    qaAnswers: {},
    attending_days: [],
    attending_times: [],
    check_acknowledgement: 0,
    signature: "",
  });
  const [admission_question_answer, setAdmissionQuestionAnswer] = useState([]);
  const [otherAllergiesButtonValue, setOtherAllergiesButtonValue] = useState({
    leela_allergies_button: "No",
    leela_dietry_intolerances_button: "No",
    leela_special_req_button: "No",
  });
  const [health_declarations, setHealthDeclarations] = useState([]);
  const [picture, setPicture] = useState(null);

  const [admissionAttachmentModal, setAdmissionAttachmentModal] = useState({
    show: false,
    title: "",
    content: "",
  });

  // On component load
  useEffect(() => {
    getCountries();
    getActiveBoardAge();
    getCenterLic();
    if (aid) {
      getAdmissionData();
    }
  }, []);

  useEffect(() => {
    const initialAnswers = {};

    if (questions?.length && admission_question_answer?.length) {
      admission_question_answer.forEach((ans) => {
        const question = questions
          .flatMap((group) => group.admission_questions || [])
          .find((q) => q.adm_quest_id === ans.adm_quest_id);

        if (question) {
          const isTrueFalse = question?.adm_tf === 1;

          initialAnswers[ans.adm_quest_id] = {
            value: isTrueFalse
              ? ans.adm_ans_answer?.toString()
              : ans.adm_ans_comment || "",

            comment: isTrueFalse ? ans.adm_ans_comment || "" : "",
            adm_ans_id: ans.adm_ans_id,
          };
        }
      });

      setFormData((prevData) => ({
        ...prevData,
        qaAnswers: initialAnswers,
      }));
    }
  }, [questions, admission_question_answer]);

  // Get countries
  const getCountries = async () => {
    try {
      const response = await fetch(`${API_URL}/get-countries`, {
        method: "GET",
      });
      if (response.ok) {
        const data = await response.json();
        setCountries(data);
      } else {
        console.log("NOT OK");
      }
    } catch (error) {
      console.log("Error!");
      console.log(error);
    }
  };

  const getActiveBoardAge = async () => {
    try {
      const response = await fetch(
        `${API_URL}/get-active-board-age-groups?center_id=31&tenant_id=0h73903ce73h41d4a7165e8429j19870`,
        {
          method: "GET",
        },
      );
      if (response.ok) {
        const data = await response.json();
        setAgeGroup(data);
      } else {
        console.log("NOT OK");
      }
    } catch (error) {
      console.log("Error!");
      console.log(error);
    }
  };

  const getClasses = async (agegroup_id) => {
    try {
      const response = await fetch(
        `${API_URL}/get-classes?center_id=31&agegroup_id=${agegroup_id}&tenant_id=0h73903ce73h41d4a7165e8429j19870`,
        {
          method: "GET",
        },
      );
      if (response.ok) {
        const data = await response.json();
        setClasses(data);
      } else {
        console.log("NOT OK");
      }
    } catch (error) {
      console.log("Error!");
      console.log(error);
    }
  };

  const getCenterLic = async () => {
    try {
      const response = await fetch(
        `${API_URL}/get-centerlic?center_id=31&tenant_id=0h73903ce73h41d4a7165e8429j19870`,
        {
          method: "GET",
        },
      );
      if (response.ok) {
        const data = await response.json();
        setCenterLicData(data);
      } else {
        console.log("NOT OK");
      }
    } catch (error) {
      console.log("Error!");
      console.log(error);
    }
  };

  // Get admission data
  const getAdmissionData = async () => {
    try {
      const response = await fetch(
        `${API_URL}/get-admission-data?admission_uuid=${aid}`,
        {
          method: "GET",
        },
      );
      if (response.ok) {
        const data = await response.json();
        const {
          admission,
          admission_extra_info,
          children_health,
          admissioncountries,
          admissionsiblings,
          admision_quest_answer,
        } = data;

        setAdmissionQuestionAnswer(admision_quest_answer);

        setFormData((prevData) => ({
          ...prevData,
          center_id: admission.center_id,
          // center_uuid: center_uuid.center_uuid,
          admission_id: admission.admission_id,
          child_name: admission.child_name,
          child_middle_name: admission.child_middle_name,
          child_last_name: admission.child_last_name,
          birth_date: admission.birth_date,
          joining_date: admission.joining_date,
          gender: admission.gender,
          country_id: admission.country_id,
          country_id2: admission.country_id2,
          religion: admission_extra_info.religion,
          birth_city: admission.birth_city,
          agegroup_id: admission.agegroup_id,
          centerlic_id: admission.centerlic_id,
          passport_number: admission.passport_number,
          passport_validity: admission.passport_validity,
          sponsor_role: admission_extra_info.sponsor_role ?? "Father",
          father_name: admission.father_name,
          grandfather_name: admission.grandfather_name,
          father_mobile: admission.father_mobile,
          father_workphone: admission.father_workphone,
          father_email: admission.father_email,
          father_employer: admission.father_employer,
          father_position: admission.father_position,
          father_income: admission_extra_info.father_income,
          father_language: admission.father_language,
          father_country_id: admission.father_country_id,
          father_passport_num: admission_extra_info.father_passport_num,
          father_passport_validity:
            admission_extra_info.father_passport_validity,
          father_residency_number: admission_extra_info.father_residency_number,
          father_residency_validity:
            admission_extra_info.father_residency_validity,
          home_address: admission.home_address,
          spouse_role: admission_extra_info.spouse_role ?? "Mother",
          mother_name: admission.mother_name,
          mother_mobile: admission.mother_mobile,
          mother_workphone: admission.mother_workphone,
          mother_email: admission.mother_email,
          mother_employer: admission.mother_employer,
          mother_position: admission.mother_position,
          mother_language: admission.mother_language,
          mother_income: admission_extra_info.mother_income,
          mother_country_id: admission.mother_country_id,
          mother_passport_num: admission_extra_info.mother_passport_num,
          mother_passport_validity:
            admission_extra_info.mother_passport_validity,
          mother_residency_number: admission_extra_info.mother_residency_number,
          mother_residency_validity:
            admission_extra_info.mother_residency_validity,
          child_school_attending: admission_extra_info.child_school_attending,
          emergency_contact1: admission.emergency_contact1,
          emergency_relation1: admission.emergency_relation1,
          emergency_phone1: admission.emergency_phone1,
          emergency_contact2: admission.emergency_contact2,
          emergency_relation2: admission.emergency_relation2,
          emergency_phone2: admission.emergency_phone2,
          nanny_name: admission.nanny_name,
          nanny_phone: admission.nanny_phone,
          driver_name: admission.driver_name,
          driver_phone: admission.driver_phone,
          admissioncountries: admissioncountries?.length
            ? admissioncountries
            : [],
          admission_siblings: admissionsiblings?.length
            ? admissionsiblings
            : [],
          first_lang: admission.first_lang,
          second_lang: admission.second_lang,
          third_lang: admission.third_lang,
          reading_prof: admission.reading_prof,
          writing_prof: admission.writing_prof,
          speaking_prof: admission.speaking_prof,
          bloodgroup: admission.bloodgroup,
          current_curr: admission.current_curr,
          child_sen: admission.child_sen,
          id_number: admission.id_number,
          previous_enroll: admission.previous_enroll,
          residency_number: admission.residency_number,
          residency_validity: admission.residency_validity,
          child_use_toilet: admission_extra_info.child_use_toilet
            ? JSON.parse(admission_extra_info.child_use_toilet)
            : [],
          pic_nursery: admission_extra_info.pic_nursery,
          pic_media: admission_extra_info.pic_media,
          pic_social: admission_extra_info.pic_social,
          take_pictures: admission_extra_info.take_pictures,
          leela_allergies: admission_extra_info.leela_allergies,
          leela_dietry_intolerances:
            admission_extra_info.leela_dietry_intolerances,
          leela_special_req: admission_extra_info.leela_special_req,
          allergies: admission.allergies,
          medicines: admission.medicines,
          allergic_reactions: admission_extra_info.allergic_reactions,
          attending_days: admission_extra_info.attending_days
            ? JSON.parse(admission_extra_info.attending_days)
            : [],
          attending_times: admission_extra_info.attending_times
            ? JSON.parse(admission_extra_info.attending_times)
            : [],
          check_acknowledgement: admission.check_acknowledgement || 0,
          signature: admission_extra_info.signature || null,
        }));

        setOtherAllergiesButtonValue((prevState) => ({
          ...prevState,
          leela_allergies_button:
            admission_extra_info.leela_allergies === "No" ? "No" : "Yes",
          leela_dietry_intolerances_button:
            admission_extra_info.leela_dietry_intolerances === "No"
              ? "No"
              : "Yes",
          leela_special_req_button:
            admission_extra_info.leela_special_req === "No" ? "No" : "Yes",
        }));
        // Health Declarations
        if (children_health.length > 0) {
          const healthDeclarations = [];
          children_health.map((item) => {
            healthDeclarations.push({
              ...item,
              uuid: chance.guid(),
            });
          });
          setHealthDeclarations(healthDeclarations);
        }

        if (admission.picture) {
          setPicture({
            preview: `${
              PORTAL_URL + center_uuid[admission.center_id]
            }/admissions_school/${admission.picture}`,
          });
        }
        if (admission_extra_info.signature) {
          setSignature({
            preview: `${
              PORTAL_URL + center_uuid.center_uuid
            }/admissions_school/${admission_extra_info.signature}`,
          });
        }
      } else {
        console.log("NOT OK");
      }
    } catch (error) {
      console.log("Error!");
      console.log(error);
    }
  };

  // Handle language change
  const handleLanguageChange = (event) => {
    setLocale(event.target.value);
  };

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (
      name === "child_use_toilet_0" ||
      name === "child_use_toilet_1" ||
      name === "child_use_toilet_2"
    ) {
      const index = name.split("_")[3];
      let child_use_toilet = formData.child_use_toilet;
      child_use_toilet[index] = value;
      setFormData((prevData) => ({
        ...prevData,
        child_use_toilet,
      }));
    } else if (name === "agegroup_id") {
      getClasses(value);
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  //Handle button change
  const handleButtonClick = (e) => {
    const { name, value } = e.target;

    // Update button value state
    setOtherAllergiesButtonValue((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    if (name === "leela_special_req_button") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        leela_special_req: value === "No" ? "No" : "",
      }));
    } else if (name === "leela_dietry_intolerances_button") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        leela_dietry_intolerances: value === "No" ? "No" : "",
      }));
    } else if (name === "leela_allergies_button") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        leela_allergies: value === "No" ? "No" : "",
      }));
    }
  };

  // Handle validation
  const validateStep = () => {
    let isValid = true;

    if (step === 1) {
      const captchaValue = recaptcha.current.getValue();

      if (!captchaValue) {
        errorsObj.captcha = true;
        isValid = false;
      }

      if (!formData.child_name) {
        errorsObj.child_name = true;
        isValid = false;
      }
      if (!formData.birth_date) {
        errorsObj.birth_date = true;
        isValid = false;
      }

      if (!formData.gender) {
        errorsObj.gender = true;
        isValid = false;
      }

      if (!formData.country_id) {
        errorsObj.country_id = true;
        isValid = false;
      }

      if (!formData.agegroup_id) {
        errorsObj.agegroup_id = true;
        isValid = false;
      }
      if (!formData.centerlic_id) {
        errorsObj.centerlic_id = true;
        isValid = false;
      }

      if (!formData.father_name) {
        errorsObj.father_name = true;
        isValid = false;
      }

      if (!formData.father_mobile) {
        errorsObj.father_mobile = true;
        isValid = false;
      }

      if (!formData.father_email) {
        errorsObj.father_email = true;
        isValid = false;
      }

      if (!formData.father_country_id) {
        errorsObj.father_country_id = true;
        isValid = false;
      }

      if (!formData.father_employer) {
        errorsObj.father_employer = true;
        isValid = false;
      }
    }
    setErrors(errorsObj);
    return isValid;
  };

  // Handle next step
  const handleNextStep = () => {
    handleSubmit(null);
  };

  function getPostData() {
    const postData = [];

    questions.forEach((group) => {
      group.admission_questions.forEach((q) => {
        const answerObj = formData.qaAnswers[q.adm_quest_id];

        const isTrueFalse = q.adm_tf === 1;

        postData.push({
          adm_ans_id: answerObj?.adm_ans_id || 0,
          center_id: formData?.center_id,
          admission_id: formData?.admission_id,
          adm_quest_id: q.adm_quest_id,
          adm_ans_answer: isTrueFalse
            ? answerObj?.value == 1
              ? 1
              : answerObj?.value == 0
                ? 0
                : null
            : 0,

          adm_ans_comment: isTrueFalse
            ? answerObj?.comment || null
            : answerObj?.value || null,
        });
      });
    });

    return postData;
  }

  const handleSubmit = async (jumpStep) => {
    let formDataObj = { ...formData };
    if (!validateStep()) {
      if (errorsObj.captcha) {
        toast.error(<FormattedMessage id="validation.captcha_required" />);
        return;
      } else {
        toast.warning(
          <FormattedMessage id="validation.fill_required_fields" />,
        );
        return;
      }
    }

    setFormSaving(true);

    try {
      const fD = new FormData();
      formDataObj.child_use_toilet = JSON.stringify(
        formDataObj.child_use_toilet,
      );
      if (step >= 6 && questions.length > 0) {
        const hasQAAnswers = Object.keys(formData.qaAnswers || {}).length > 0;
        if (hasQAAnswers) {
          const postData = getPostData();
          fD.append("answers", JSON.stringify(postData));
        }
      }

      fD.append(
        "admissioncountries",
        JSON.stringify(formDataObj.admissioncountries),
      );
      fD.append(
        "admission_siblings",
        JSON.stringify(formDataObj.admission_siblings),
      );
      fD.append("formData", JSON.stringify(formDataObj));
      fD.append("picture", picture);
      fD.append("step", step);

      if (step === 1) {
        const captchaValue = recaptcha.current.getValue();
        fD.append("g-recaptcha-response", captchaValue);
      }

      health_declarations.length > 0 &&
        health_declarations.forEach((healthDeclaration) => {
          fD.append(
            `health_declarations[uuid][${healthDeclaration.uuid}]`,
            healthDeclaration.uuid,
          );
          fD.append(
            `health_declarations[child_health_id][${healthDeclaration.uuid}]`,
            healthDeclaration.child_health_id,
          );
          fD.append(
            `health_declarations[child_health_name][${healthDeclaration.uuid}]`,
            healthDeclaration.child_health_name,
          );
          fD.append(
            `health_declarations[child_health_desc][${healthDeclaration.uuid}]`,
            healthDeclaration.child_health_desc,
          );
          fD.append(
            `health_declarations[child_health_date][${healthDeclaration.uuid}]`,
            moment(healthDeclaration.child_health_date).format("YYYY-MM-DD"),
          );
          fD.append(
            `health_declarations[child_health_type][${healthDeclaration.uuid}]`,
            healthDeclaration.child_health_type,
          );
        });

      const response = await fetch(`${API_URL}/save-admission-data`, {
        method: "POST",
        body: fD,
      });
      if (response.ok) {
        const { data, type, message } = await response.json();
        if (type) {
          const { admission, question_grps } = data;
          const { admission_id, admission_uuid } = admission;
          setQuestions(question_grps);
          setFormData((prevData) => ({
            ...prevData,
            admission_id,
          }));
          window.history.pushState(
            { aid: admission_id },
            "",
            `?aid=${admission_uuid}`,
          );

          let stepNum = 0;

          if (step < steps.length && !jumpStep) {
            stepNum = step + 1;
            setStep(stepNum);
            setStepName(steps[stepNum - 1].name);
          } else if (jumpStep) {
            stepNum = jumpStep;
            setStep(stepNum);
            setStepName(steps[stepNum - 1].name);
          }

          const isLastStep = step === steps.length;

          if (isLastStep) {
            toast.success("Successfully Submitted");
          } else {
            toast.success(
              <FormattedMessage id="validation.saved_successfully" />,
            );
          }
        } else {
          if (message) {
            toast.info(message);
          }
          console.log("Error submitting form");
        }
      } else {
        console.log("Error submitting form");
      }
      setFormSaving(false);
    } catch (error) {
      setFormSaving(false);
      console.log("Something went wrong!");
      console.log(error);
    }
  };

  return (
    <IntlProvider locale={locale} messages={messages[locale]}>
      <div id="page" dir={locale === "en" || locale === "ro" ? "ltr" : "rtl"}>
        <aside id="sidebar" className="d-none d-md-block position-relative">
          <small
            className="text-muted"
            style={{
              position: "absolute",
              bottom: 20,
              left: locale === "en" ? 20 : "auto",
              right: locale === "ar" ? 20 : "auto",
            }}
          >
            v{version}
          </small>
          <Row className="aside-header">
            <Col>
              <img
                src={require("./assets/genesis-ib-alb.png")}
                alt="Educore"
                width="150"
              />
            </Col>
            <Col className="lang-switcher text-end">
              <ButtonGroup>
                <Button
                  size="sm"
                  onClick={handleLanguageChange}
                  value="en"
                  variant={locale === "en" ? "secondary" : "light"}
                >
                  EN
                </Button>
                <Button
                  size="sm"
                  onClick={handleLanguageChange}
                  value="ro"
                  variant={locale === "ro" ? "secondary" : "light"}
                >
                  RO
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <div className="steps-list">
            <ul>
              {steps.map((item, index) => (
                <li key={index} className={step === index + 1 ? "active" : ""}>
                  <Button
                    variant="link"
                    onClick={() => {
                      handleSubmit(index + 1);
                    }}
                  >
                    <FormattedMessage id={item.name} />
                  </Button>
                </li>
              ))}
            </ul>
          </div>
        </aside>
        <div id="content">
          <Row className="res-header d-md-none">
            <Col>
              <img
                src={require("./assets/genesis-ib-alb.png")}
                alt="CHM"
                width="150"
              />
            </Col>
            <Col className="lang-switcher text-end">
              <ButtonGroup>
                <Button
                  size="sm"
                  onClick={handleLanguageChange}
                  value="en"
                  variant={locale === "en" ? "secondary" : "light"}
                >
                  EN
                </Button>
                <Button
                  size="sm"
                  onClick={handleLanguageChange}
                  value="ro"
                  variant={locale === "ro" ? "secondary" : "light"}
                >
                  RO
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <div id="content_child" className="position-relative">
            <div className="form-nav">
              <Button
                variant={"primary"}
                onClick={handleNextStep}
                disabled={formSaving}
              >
                <FormattedMessage
                  id={step === steps.length ? "submit" : "next"}
                />
              </Button>
            </div>
            <h2 className="mb-3">
              <FormattedMessage id={stepName} />
            </h2>

            {/* STEP 1 */}
            {step === 1 && (
              <>
                <Row>
                  <Col md={6} lg={3} xl={4} xxl={2}>
                    <FilePicker
                      name="picture"
                      file={picture}
                      setFile={setPicture}
                      height={200}
                    />
                  </Col>
                  <Col
                    md={6}
                    lg={3}
                    xxl={2}
                    className="d-flex align-items-center"
                  >
                    <FormattedMessage id="child_picture" />
                  </Col>
                  <Col></Col>

                  <Col
                    md={12}
                    xxl={6}
                    className="ml-lg-auto d-flex flex-column flex-lg-row align-items-lg-center justify-content-lg-end gap-5 flex-column-reverse mt-5 lg:mt-3"
                  >
                    <ReCAPTCHA
                      ref={recaptcha}
                      sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                    />
                  </Col>
                </Row>

                {/* Child Details */}
                <SectionSeparator title="title.child_details" />
                <Row>
                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      <span className="required-field">*</span>
                      <FormattedMessage id="child_name">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.child_name}
                            placeholder={placeholder}
                            type="text"
                            name="child_name"
                            onChange={handleChange}
                            isInvalid={!!errors.child_name}
                          />
                        )}
                      </FormattedMessage>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.child_name" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  {/* <Col md={3}>
                  <Form.Group className="mb-4">
                    <FormattedMessage id="child_middle_name">
                      {(placeholder) => (
                        <Form.Control
                          value={formData.child_middle_name}
                          placeholder={placeholder}
                          type="text"
                          name="child_middle_name"
                          onChange={handleChange}
                        />
                      )}
                    </FormattedMessage>
                  </Form.Group>
                </Col> 
                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      <span className="required-field">*</span>
                      <FormattedMessage id="child_last_name">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.child_last_name}
                            placeholder={placeholder}
                            type="text"
                            name="child_last_name"
                            onChange={handleChange}
                            isInvalid={!!errors.child_last_name}
                          />
                        )}
                      </FormattedMessage>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.child_last_name" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>*/}
                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      <span className="required-field">*</span>
                      <FormattedMessage id="birth_date">
                        {(placeholder) => (
                          <DatePicker
                            placeholderText={placeholder}
                            className={
                              errors.birth_date
                                ? " form-control is-invalid"
                                : "form-control"
                            }
                            selected={
                              formData.birth_date
                                ? new Date(formData.birth_date)
                                : null
                            }
                            onChange={(date) => {
                              if (date) {
                                const formattedDate =
                                  moment(date).format("YYYY-MM-DD");
                                setFormData((prev) => ({
                                  ...prev,
                                  birth_date: formattedDate,
                                }));
                              } else {
                                setFormData((prev) => ({
                                  ...prev,
                                  birth_date: null,
                                }));
                              }
                            }}
                            dateFormat="dd/MM/yyyy"
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            isClearable
                          />
                        )}
                      </FormattedMessage>
                      <div
                        className={errors.birth_date ? "is-invalid" : ""}
                      ></div>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.birth_date" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  {/* <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      <span className="required-field">*</span>
                      <FormattedMessage id="birth_city">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.birth_city}
                            placeholder={placeholder}
                            type="text"
                            name="birth_city"
                            onChange={handleChange}
                            isInvalid={!!errors.birth_city}
                          />
                        )}
                      </FormattedMessage>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.birth_city" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col> */}

                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      <span className="required-field">*</span>
                      <Form.Select
                        name="gender"
                        onChange={handleChange}
                        value={formData.gender}
                        isInvalid={!!errors.gender}
                      >
                        <option value="">
                          <FormattedMessage id="select_gender" />
                        </option>
                        <option value="F">
                          <FormattedMessage id="female" />
                        </option>
                        <option value="M">
                          <FormattedMessage id="male" />
                        </option>
                      </Form.Select>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.gender" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      <span className="required-field">*</span>
                      <Form.Select
                        onChange={handleChange}
                        name="country_id"
                        value={formData.country_id}
                        isInvalid={!!errors.country_id}
                      >
                        <option value="">
                          <FormattedMessage id="select_nationality" />
                        </option>
                        {countries.map((country, index) => (
                          <option key={index} value={country.country_id}>
                            {country.name_en}
                          </option>
                        ))}
                      </Form.Select>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.country_id" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      <span className="required-field">*</span>
                      <Form.Select
                        name="centerlic_id"
                        onChange={handleChange}
                        value={formData.centerlic_id}
                        isInvalid={!!errors.centerlic_id}
                      >
                        <option value="">
                          <FormattedMessage id="centerlic_id" />
                        </option>
                        {centerLicData?.map((language, index) => (
                          <option key={index} value={language.centerlic_id}>
                            {language.description}
                          </option>
                        ))}
                      </Form.Select>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.centerlic_id" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      <span className="required-field">*</span>
                      <Form.Select
                        name="agegroup_id"
                        onChange={handleChange}
                        value={formData.agegroup_id}
                        isInvalid={!!errors.agegroup_id}
                      >
                        <option value="">
                          <FormattedMessage id="agegroup_id" />
                        </option>
                        {ageGroup?.map((language, index) => (
                          <option key={index} value={language.agegroup_id}>
                            {language.agegroup_code}
                          </option>
                        ))}
                      </Form.Select>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.agegroup_id" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  {/* {classes.length > 0 && (
                    <Col md={3}>
                      <Form.Group className="mb-4 position-relative">
                        <Form.Select
                          name="class_id"
                          onChange={handleChange}
                          value={formData.class_id || ""}
                          isInvalid={!!errors.class_id}
                        >
                          <option value="">
                          <FormattedMessage id="class_id" />
                        </option>

                          {classes?.map((cls, index) => (
                            <option key={index} value={cls.class_id}>
                              {cls.class_theme}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  )} */}

                  {/* <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      <Form.Select
                        onChange={handleChange}
                        name="country_id2"
                        value={formData.country_id2}
                        // isInvalid={!!errors.country_id2}
                      >
                        <option value="">
                          <FormattedMessage id="country_id2" />
                        </option>
                        {countries.map((country, index) => (
                          <option key={index} value={country.country_id}>
                            {country.name_en}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col> 

                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      <span className="required-field">*</span>
                      <Form.Select
                        onChange={handleChange}
                        name="religion"
                        value={formData.religion}
                        isInvalid={!!errors.religion}
                      >
                        <option value="">
                          <FormattedMessage id="select_religion" />
                        </option>
                        <option value="1">
                          <FormattedMessage id="other" />
                        </option>
                        <option value="2">
                          <FormattedMessage id="muslim" />
                        </option>
                        <option value="3">
                          <FormattedMessage id="christian" />
                        </option>
                      </Form.Select>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.select_religion" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="1st_language">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.first_lang}
                            placeholder={placeholder}
                            type="text"
                            name="first_lang"
                            onChange={handleChange}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="2nd_language">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.second_lang}
                            placeholder={placeholder}
                            type="text"
                            name="second_lang"
                            onChange={handleChange}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="2nd_language">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.third_lang}
                            placeholder={placeholder}
                            type="text"
                            name="third_lang"
                            onChange={handleChange}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col> 

                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      <span className="required-field">*</span>
                      <Form.Select
                        onChange={handleChange}
                        name="child_sen"
                        value={formData.child_sen}
                        isInvalid={!!errors.child_sen}
                      >
                        <option value="">
                          <FormattedMessage id="child_sen" />
                        </option>
                        <option value={1}>
                          <FormattedMessage id="yes" />
                        </option>
                        <option value={0}>
                          <FormattedMessage id="no" />
                        </option>
                      </Form.Select>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.child_sen" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="passport_num">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.passport_number}
                            placeholder={placeholder}
                            type="text"
                            name="passport_number"
                            onChange={handleChange}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="passport_validity">
                        {(placeholder) => (
                          <DatePicker
                            placeholderText={placeholder}
                            className={
                              errors?.passport_validity
                                ? " form-control is-invalid"
                                : "form-control"
                            }
                            selected={formData.passport_validity}
                            onChange={(date) =>
                              setFormData((prevData) => ({
                                ...prevData,
                                passport_validity: date,
                              }))
                            }
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="residency_number">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.residency_number}
                            placeholder={placeholder}
                            type="text"
                            name="residency_number"
                            onChange={handleChange}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="residency_validity">
                        {(placeholder) => (
                          <DatePicker
                            placeholderText={placeholder}
                            className={
                              errors.residency_validity
                                ? " form-control is-invalid"
                                : "form-control"
                            }
                            selected={formData.residency_validity}
                            onChange={(date) =>
                              setFormData((prevData) => ({
                                ...prevData,
                                residency_validity: date,
                              }))
                            }
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      <span className="required-field">*</span>
                      <FormattedMessage id="id_number">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.id_number}
                            placeholder={placeholder}
                            type="text"
                            name="id_number"
                            onChange={handleChange}
                            isInvalid={!!errors.id_number}
                          />
                        )}
                      </FormattedMessage>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.id_number" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <Form.Select
                        onChange={handleChange}
                        name="previous_enroll"
                        value={formData.previous_enroll}
                      >
                        <option value="">
                          <FormattedMessage id="previous_enroll" />
                        </option>
                        <option value={1}>
                          <FormattedMessage id="yes" />
                        </option>
                        <option value={0}>
                          <FormattedMessage id="no" />
                        </option>
                      </Form.Select>
                    </Form.Group>
                  </Col> */}
                </Row>

                {/* Family Details */}
                <SectionSeparator title="title.family_details" />

                <SubSectionSeparator title="title.spouse_information" />
                <Row>
                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      <FormattedMessage id="full_name">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.mother_name}
                            placeholder={placeholder}
                            type="text"
                            name="mother_name"
                            onChange={handleChange}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      <FormattedMessage id="email_address">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.mother_email}
                            placeholder={placeholder}
                            type="text"
                            name="mother_email"
                            onChange={handleChange}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      <Form.Select
                        onChange={handleChange}
                        name="mother_country_id"
                        value={formData.mother_country_id}
                        // isInvalid={!!errors.mother_country_id}
                      >
                        <option value="">
                          <FormattedMessage id="select_nationality" />
                        </option>
                        {countries.map((country, index) => (
                          <option key={index} value={country.country_id}>
                            {country.name_en}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      <FormattedMessage id="mobile_number">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.mother_mobile}
                            placeholder={placeholder}
                            type="text"
                            name="mother_mobile"
                            onChange={handleChange}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                  {/* <Col md={3} xxl={2}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="work_number">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.mother_workphone}
                            placeholder={placeholder}
                            type="text"
                            name="mother_workphone"
                            onChange={handleChange}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col> */}

                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="place_of_work">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.mother_employer}
                            placeholder={placeholder}
                            type="text"
                            name="mother_employer"
                            onChange={handleChange}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="occupation">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.mother_position}
                            placeholder={placeholder}
                            type="text"
                            name="mother_position"
                            onChange={handleChange}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>

                  {/* <Col md={3} xxl={2}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="income">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.mother_income}
                            placeholder={placeholder}
                            type="text"
                            name="mother_income"
                            onChange={handleChange}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col> 
                  <Col md={3} xxl={2}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="language">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.mother_language}
                            placeholder={placeholder}
                            type="text"
                            name="mother_language"
                            onChange={handleChange}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                  <Col md={3} xxl={2}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="passport_num">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.mother_passport_num}
                            placeholder={placeholder}
                            type="text"
                            name="mother_passport_num"
                            onChange={handleChange}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                  <Col md={3} xxl={2}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="passport_validity">
                        {(placeholder) => (
                          <DatePicker
                            placeholderText={placeholder}
                            className={
                              errors.mother_passport_validity
                                ? " form-control is-invalid"
                                : "form-control"
                            }
                            selected={formData.mother_passport_validity}
                            onChange={(date) =>
                              setFormData((prevData) => ({
                                ...prevData,
                                mother_passport_validity: date,
                              }))
                            }
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                  <Col md={3} xxl={2}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="residency_number">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.mother_residency_number}
                            placeholder={placeholder}
                            type="text"
                            name="mother_residency_number"
                            onChange={handleChange}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                  <Col md={3} xxl={2}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="residency_validity">
                        {(placeholder) => (
                          <DatePicker
                            placeholderText={placeholder}
                            className={
                              errors.mother_residency_validity
                                ? " form-control is-invalid"
                                : "form-control"
                            }
                            selected={formData.mother_residency_validity}
                            onChange={(date) =>
                              setFormData((prevData) => ({
                                ...prevData,
                                mother_residency_validity: date,
                              }))
                            }
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>*/}
                </Row>
                <SubSectionSeparator title="title.sponsor_parent_information" />
                <Row>
                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      <span className="required-field">*</span>
                      <FormattedMessage id="full_name">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.father_name}
                            placeholder={placeholder}
                            type="text"
                            name="father_name"
                            onChange={handleChange}
                            isInvalid={!!errors.father_name}
                          />
                        )}
                      </FormattedMessage>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.full_name" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      <span className="required-field">*</span>
                      <FormattedMessage id="email_address">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.father_email}
                            placeholder={placeholder}
                            type="text"
                            name="father_email"
                            onChange={handleChange}
                            isInvalid={!!errors.father_email}
                          />
                        )}
                      </FormattedMessage>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.email" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      <span className="required-field">*</span>
                      <Form.Select
                        onChange={handleChange}
                        name="father_country_id"
                        value={formData.father_country_id}
                        isInvalid={!!errors.father_country_id}
                      >
                        <option value="">
                          <FormattedMessage id="select_nationality" />
                        </option>
                        {countries.map((country, index) => (
                          <option key={index} value={country.country_id}>
                            {country.name_en}
                          </option>
                        ))}
                      </Form.Select>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.country_id" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      <span className="required-field">*</span>
                      <FormattedMessage id="mobile_number">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.father_mobile}
                            placeholder={placeholder}
                            type="text"
                            name="father_mobile"
                            onChange={handleChange}
                            isInvalid={!!errors.father_mobile}
                          />
                        )}
                      </FormattedMessage>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.mobile" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  {/* <Col md={3} xxl={2}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="work_number">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.father_workphone}
                            placeholder={placeholder}
                            type="text"
                            name="father_workphone"
                            onChange={handleChange}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col> */}

                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      <span className="required-field">*</span>
                      <FormattedMessage id="place_of_work">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.father_employer}
                            placeholder={placeholder}
                            type="text"
                            name="father_employer"
                            onChange={handleChange}
                            isInvalid={!!errors.father_employer}
                          />
                        )}
                      </FormattedMessage>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.place_of_work" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="occupation">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.father_position}
                            placeholder={placeholder}
                            type="text"
                            name="father_position"
                            onChange={handleChange}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>

                  {/*<Col md={3} xxl={2}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="income">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.father_income}
                            placeholder={placeholder}
                            type="text"
                            name="father_income"
                            onChange={handleChange}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                  <Col md={3} xxl={2}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="passport_num">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.father_passport_num}
                            placeholder={placeholder}
                            type="text"
                            name="father_passport_num"
                            onChange={handleChange}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                  <Col md={3} xxl={2}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="passport_validity">
                        {(placeholder) => (
                          <DatePicker
                            placeholderText={placeholder}
                            className={
                              errors.father_passport_validity
                                ? " form-control is-invalid"
                                : "form-control"
                            }
                            selected={formData.father_passport_validity}
                            onChange={(date) =>
                              setFormData((prevData) => ({
                                ...prevData,
                                father_passport_validity: date,
                              }))
                            }
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                  <Col md={3} xxl={2}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="residency_number">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.father_residency_number}
                            placeholder={placeholder}
                            type="text"
                            name="father_residency_number"
                            onChange={handleChange}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                  <Col md={3} xxl={2}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="residency_validity">
                        {(placeholder) => (
                          <DatePicker
                            placeholderText={placeholder}
                            className={
                              errors.father_residency_validity
                                ? " form-control is-invalid"
                                : "form-control"
                            }
                            selected={formData.father_residency_validity}
                            onChange={(date) =>
                              setFormData((prevData) => ({
                                ...prevData,
                                father_residency_validity: date,
                              }))
                            }
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                  <Col md={3} xxl={2}>
                    <Form.Group className="mb-4 position-relative">
                      <span className="required-field">*</span>
                      <FormattedMessage id="language">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.father_language}
                            placeholder={placeholder}
                            type="text"
                            name="father_language"
                            onChange={handleChange}
                            isInvalid={!!errors.father_language}
                          />
                        )}
                      </FormattedMessage>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.language" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={3} xxl={2}>
                    <Form.Group className="mb-4 position-relative">
                      <FormattedMessage id="grandfather_name">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.grandfather_name}
                            placeholder={placeholder}
                            type="text"
                            name="grandfather_name"
                            onChange={handleChange}
                            isInvalid={!!errors.grandfather_name}
                          />
                        )}
                      </FormattedMessage>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.full_name" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>*/}
                </Row>

                <SubSectionSeparator title="title.sibling_information" />
                <AdmissionSiblings
                  errors={errors}
                  admissionSiblings={formData.admission_siblings}
                  setFormData={setFormData}
                />

                {/* <SectionSeparator title="title.emergency_contact" />
                <SubSectionSeparator title="title.emergency_persons" />
                <Row>
                  <Col md={4}>
                    <Form.Group className="mb-4 position-relative">
                      <span className="required-field">*</span>
                      <FormattedMessage id="name">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.emergency_contact1}
                            placeholder={placeholder}
                            type="text"
                            name="emergency_contact1"
                            onChange={handleChange}
                            isInvalid={!!errors.emergency_contact1}
                          />
                        )}
                      </FormattedMessage>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.emergency_contact_name" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className="mb-4 position-relative">
                      <span className="required-field">*</span>
                      <FormattedMessage id="relation">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.emergency_relation1}
                            placeholder={placeholder}
                            type="text"
                            name="emergency_relation1"
                            onChange={handleChange}
                            isInvalid={!!errors.emergency_relation1}
                          />
                        )}
                      </FormattedMessage>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.emergency_contact_relation" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className="mb-4 position-relative">
                      <span className="required-field">*</span>
                      <FormattedMessage id="contact_number">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.emergency_phone1}
                            placeholder={placeholder}
                            type="text"
                            name="emergency_phone1"
                            onChange={handleChange}
                            isInvalid={!!errors.emergency_phone1}
                          />
                        )}
                      </FormattedMessage>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.emergency_contact_number" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row> 

                <Row>
                  <Col md={4}>
                    <Form.Group className="mb-4 position-relative">

                      <FormattedMessage id="name">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.emergency_contact2}
                            placeholder={placeholder}
                            type="text"
                            name="emergency_contact2"
                            onChange={handleChange}
                            isInvalid={!!errors.emergency_contact2}
                          />
                        )}
                      </FormattedMessage>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.emergency_contact_name" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className="mb-4 position-relative">
                      <FormattedMessage id="relation">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.emergency_relation2}
                            placeholder={placeholder}
                            type="text"
                            name="emergency_relation2"
                            onChange={handleChange}
                            isInvalid={!!errors.emergency_relation2}
                          />
                        )}
                      </FormattedMessage>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.emergency_contact_relation" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className="mb-4 position-relative">

                      <FormattedMessage id="contact_number">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.emergency_phone2}
                            placeholder={placeholder}
                            type="text"
                            name="emergency_phone2"
                            onChange={handleChange}
                            isInvalid={!!errors.emergency_phone2}
                          />
                        )}
                      </FormattedMessage>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.emergency_contact_number" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>*/}
                {/*<SectionSeparator title="title.other_contact" />

                <Row>
                  <Col md={6}>
                    <SubSectionSeparator title="nanny" />
                    <Row>
                      <Col md={6}>
                        <Form.Group className="mb-4 position-relative">
                          <span className="required-field">*</span>
                          <FormattedMessage id="name">
                            {(placeholder) => (
                              <Form.Control
                                value={formData.nanny_name}
                                placeholder={placeholder}
                                type="text"
                                name="nanny_name"
                                onChange={handleChange}
                                isInvalid={!!errors.nanny_name}
                              />
                            )}
                          </FormattedMessage>
                          <Form.Control.Feedback
                            className="px-3"
                            type="invalid"
                          >
                            <FormattedMessage id="error.nanny_name" />
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group className="mb-4 position-relative">
                          <span className="required-field">*</span>
                          <FormattedMessage id="contact_number">
                            {(placeholder) => (
                              <Form.Control
                                value={formData.nanny_phone}
                                placeholder={placeholder}
                                type="text"
                                name="nanny_phone"
                                onChange={handleChange}
                                isInvalid={!!errors.nanny_phone}
                              />
                            )}
                          </FormattedMessage>
                          <Form.Control.Feedback
                            className="px-3"
                            type="invalid"
                          >
                            <FormattedMessage id="error.nanny_phone" />
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Col>{" "}
                  <Col md={6}>
                    <SubSectionSeparator title="driver" />
                    <Row>
                      <Col md={6}>
                        <Form.Group className="mb-4 position-relative">
                          <span className="required-field">*</span>
                          <FormattedMessage id="name">
                            {(placeholder) => (
                              <Form.Control
                                value={formData.driver_name}
                                placeholder={placeholder}
                                type="text"
                                name="driver_name"
                                onChange={handleChange}
                                isInvalid={!!errors.driver_name}
                              />
                            )}
                          </FormattedMessage>
                          <Form.Control.Feedback
                            className="px-3"
                            type="invalid"
                          >
                            <FormattedMessage id="error.driver_name" />
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="mb-4 position-relative">
                          <span className="required-field">*</span>
                          <FormattedMessage id="contact_number">
                            {(placeholder) => (
                              <Form.Control
                                value={formData.driver_phone}
                                placeholder={placeholder}
                                type="text"
                                name="driver_phone"
                                onChange={handleChange}
                                isInvalid={!!errors.driver_phone}
                              />
                            )}
                          </FormattedMessage>
                          <Form.Control.Feedback
                            className="px-3"
                            type="invalid"
                          >
                            <FormattedMessage id="error.driver_phone" />
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Col>
                </Row>

                <SectionSeparator title="title.academic_proficiency" />

                <Row>
                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="current_curr">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.current_curr}
                            placeholder={placeholder}
                            type="text"
                            name="current_curr"
                            onChange={handleChange}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <Form.Select
                        onChange={handleChange}
                        name="reading_prof"
                        value={formData.reading_prof}
                      >
                        <option value="">
                          <FormattedMessage id="reading_prof" />
                        </option>
                        <option value="Beginner">
                          <FormattedMessage id="beginner" />
                        </option>
                        <option value="Intermediate">
                          <FormattedMessage id="intermediate" />
                        </option>
                        <option value="Advanced">
                          <FormattedMessage id="advanced" />
                        </option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <Form.Select
                        onChange={handleChange}
                        name="writing_prof"
                        value={formData.writing_prof}
                      >
                        <option value="">
                          <FormattedMessage id="writing_prof" />
                        </option>
                        <option value="Beginner">
                          <FormattedMessage id="beginner" />
                        </option>
                        <option value="Intermediate">
                          <FormattedMessage id="intermediate" />
                        </option>
                        <option value="Advanced">
                          <FormattedMessage id="advanced" />
                        </option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <Form.Select
                        onChange={handleChange}
                        name="speaking_prof"
                        value={formData.speaking_prof}
                      >
                        <option value="">
                          <FormattedMessage id="speaking_prof" />
                        </option>
                        <option value="Beginner">
                          <FormattedMessage id="beginner" />
                        </option>
                        <option value="Intermediate">
                          <FormattedMessage id="intermediate" />
                        </option>
                        <option value="Advanced">
                          <FormattedMessage id="advanced" />
                        </option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
                <SectionSeparator title="title.admission_countries" />

                <AdmissionCountries
                  admissioncountries={formData.admissioncountries}
                  errors={errors}
                  setFormData={setFormData}
                /> */}
              </>
            )}

            {/* STEP 2 
            {step === 2 && (
              <>
                <SubSectionSeparator title="visual_media_consent" />
                <Row>
                  <Col md={12}>
                    <Form.Group className="mb-4">
                      <ButtonGroup className="me-3 ms-0">
                        <Button
                          size="sm"
                          name="pic_nursery"
                          onClick={handleChange}
                          value={1}
                          variant={
                            formData?.pic_nursery == 1 ? "secondary" : "light"
                          }
                        >
                          <FormattedMessage id="yes" />
                        </Button>
                        <Button
                          size="sm"
                          name="pic_nursery"
                          onClick={handleChange}
                          value={0}
                          variant={
                            formData?.pic_nursery == 0 ? "secondary" : "light"
                          }
                        >
                          <FormattedMessage id="no" />
                        </Button>
                      </ButtonGroup>
                      <Form.Label>
                        <FormattedMessage id="social_media_website" />
                      </Form.Label>
                    </Form.Group>
                  </Col>
                  <Col md={12}>
                    <Form.Group className="mb-4">
                      <ButtonGroup className="me-3 ms-0">
                        <Button
                          size="sm"
                          name="pic_media"
                          onClick={handleChange}
                          value={1}
                          variant={
                            formData?.pic_media == 1 ? "secondary" : "light"
                          }
                        >
                          <FormattedMessage id="yes" />
                        </Button>
                        <Button
                          size="sm"
                          name="pic_media"
                          onClick={handleChange}
                          value={0}
                          variant={
                            formData?.pic_media == 0 ? "secondary" : "light"
                          }
                        >
                          <FormattedMessage id="no" />
                        </Button>
                      </ButtonGroup>
                      <Form.Label>
                        <FormattedMessage id="advertising" />
                      </Form.Label>
                    </Form.Group>
                  </Col>
                  <Col md={12}>
                    <Form.Group className="mb-4">
                      <ButtonGroup className="me-3 ms-0">
                        <Button
                          size="sm"
                          name="pic_social"
                          onClick={handleChange}
                          value={1}
                          variant={
                            formData?.pic_social == 1 ? "secondary" : "light"
                          }
                        >
                          <FormattedMessage id="yes" />
                        </Button>
                        <Button
                          size="sm"
                          name="pic_social"
                          onClick={handleChange}
                          value={0}
                          variant={
                            formData?.pic_social == 0 ? "secondary" : "light"
                          }
                        >
                          <FormattedMessage id="no" />
                        </Button>
                      </ButtonGroup>
                      <Form.Label>
                        <FormattedMessage id="printing" />
                      </Form.Label>
                    </Form.Group>
                  </Col>
                </Row>
              </>
            )}*/}

            {/* STEP 2 */}
            {step === 2 && (
              <>
                <SectionSeparator title="title.food_other_allergy" />
                <Row>
                  <Col md={12} className="mb-4">
                    <Row>
                      <Col md={3} xxl={2}>
                        <Form.Label style={{ paddingTop: 3, marginBottom: 11 }}>
                          <FormattedMessage id="known_allergies" />
                        </Form.Label>
                      </Col>
                      <Col md={1} style={{ paddingTop: 3 }}>
                        <ButtonGroup className="mx-3">
                          <Button
                            size="sm"
                            name="leela_allergies_button"
                            value="Yes"
                            variant={
                              otherAllergiesButtonValue.leela_allergies_button ===
                              "Yes"
                                ? "secondary"
                                : "light"
                            }
                            onClick={handleButtonClick}
                          >
                            <FormattedMessage id="yes" />
                          </Button>
                          <Button
                            size="sm"
                            name="leela_allergies_button"
                            value="No"
                            variant={
                              otherAllergiesButtonValue.leela_allergies_button ===
                              "No"
                                ? "secondary"
                                : "light"
                            }
                            onClick={handleButtonClick}
                          >
                            <FormattedMessage id="no" />
                          </Button>
                        </ButtonGroup>
                      </Col>
                      <Col md={9} className="ps-4">
                        <Form.Group className="mb-4 position-relative">
                          {otherAllergiesButtonValue.leela_allergies_button ===
                            "Yes" && (
                            <FormattedMessage id="if_yes_please_specify">
                              {(placeholder) => (
                                <Form.Control
                                  value={formData.leela_allergies}
                                  placeholder={placeholder}
                                  type="text"
                                  name="leela_allergies"
                                  onChange={handleChange}
                                  isInvalid={!!errors.leela_allergies}
                                />
                              )}
                            </FormattedMessage>
                          )}
                          <Form.Control.Feedback
                            className="px-3"
                            type="invalid"
                          >
                            <FormattedMessage id="error.leela_allergies" />
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Col>
                  <Col md={12} className="mb-4">
                    <Row>
                      <Col md={3} xxl={2}>
                        <Form.Label style={{ paddingTop: 3, marginBottom: 11 }}>
                          <FormattedMessage id="dietary_intolerance" />
                        </Form.Label>
                      </Col>
                      <Col md={1} style={{ paddingTop: 3 }}>
                        <ButtonGroup className="mx-3">
                          <Button
                            size="sm"
                            name="leela_dietry_intolerances_button"
                            onClick={handleButtonClick}
                            value="Yes"
                            variant={
                              otherAllergiesButtonValue.leela_dietry_intolerances_button ===
                              "Yes"
                                ? "secondary"
                                : "light"
                            }
                          >
                            <FormattedMessage id="yes" />
                          </Button>
                          <Button
                            size="sm"
                            name="leela_dietry_intolerances_button"
                            onClick={handleButtonClick}
                            value="No"
                            variant={
                              otherAllergiesButtonValue.leela_dietry_intolerances_button ===
                              "No"
                                ? "secondary"
                                : "light"
                            }
                          >
                            <FormattedMessage id="no" />
                          </Button>
                        </ButtonGroup>
                      </Col>
                      <Col md={9} className="ps-4">
                        <Form.Group className="mb-4 position-relative">
                          {otherAllergiesButtonValue.leela_dietry_intolerances_button ===
                            "Yes" && (
                            <FormattedMessage id="if_yes_please_specify">
                              {(placeholder) => (
                                <Form.Control
                                  value={formData.leela_dietry_intolerances}
                                  placeholder={placeholder}
                                  type="text"
                                  name="leela_dietry_intolerances"
                                  onChange={handleChange}
                                  isInvalid={!!errors.leela_dietry_intolerances}
                                />
                              )}
                            </FormattedMessage>
                          )}
                          <Form.Control.Feedback
                            className="px-3"
                            type="invalid"
                          >
                            <FormattedMessage id="error.leela_dietry_intolerances" />
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Col>
                  <Col md={12} className="mb-4">
                    <Row>
                      <Col md={3} xxl={2}>
                        <Form.Label style={{ paddingTop: 3, marginBottom: 11 }}>
                          <FormattedMessage id="special_requirements" />
                        </Form.Label>
                      </Col>
                      <Col md={1} style={{ paddingTop: 3 }}>
                        <ButtonGroup className="mx-3">
                          <Button
                            size="sm"
                            name="leela_special_req_button"
                            onClick={handleButtonClick}
                            value="Yes"
                            variant={
                              otherAllergiesButtonValue.leela_special_req_button ===
                              "Yes"
                                ? "secondary"
                                : "light"
                            }
                          >
                            <FormattedMessage id="yes" />
                          </Button>
                          <Button
                            size="sm"
                            name="leela_special_req_button"
                            onClick={handleButtonClick}
                            value="No"
                            variant={
                              otherAllergiesButtonValue.leela_special_req_button ===
                              "No"
                                ? "secondary"
                                : "light"
                            }
                          >
                            <FormattedMessage id="no" />
                          </Button>
                        </ButtonGroup>
                      </Col>
                      <Col md={9} className="ps-4">
                        <Form.Group className="mb-4 position-relative">
                          {otherAllergiesButtonValue.leela_special_req_button ===
                            "Yes" && (
                            <FormattedMessage id="if_yes_please_specify">
                              {(placeholder) => (
                                <Form.Control
                                  value={formData.leela_special_req}
                                  placeholder={placeholder}
                                  type="text"
                                  name="leela_special_req"
                                  onChange={handleChange}
                                  isInvalid={!!errors.leela_special_req}
                                />
                              )}
                            </FormattedMessage>
                          )}
                          <Form.Control.Feedback
                            className="px-3"
                            type="invalid"
                          >
                            <FormattedMessage id="error.leela_special_req" />
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <SectionSeparator title="title.other_allergy" />
                <Row>
                  <Col md={12}>
                    <Form.Group className="mb-4">
                      <Form.Label>
                        <FormattedMessage id="medicines" />
                      </Form.Label>
                      <Form.Control
                        value={formData.medicines}
                        type="text"
                        name="medicines"
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={12}>
                    <Form.Group className="mb-4">
                      <Form.Label className="position-relative">
                        <FormattedMessage id="allergies" />
                      </Form.Label>
                      <Form.Control
                        value={formData.allergies}
                        type="text"
                        name="allergies"
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={12}>
                    <Form.Group className="mb-4">
                      <Form.Label>
                        <FormattedMessage id="allergic_reactions" />
                      </Form.Label>
                      <Form.Control
                        value={formData.allergic_reactions}
                        type="text"
                        name="allergic_reactions"
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </>
            )}

            {/* STEP 5 */}
            {/* {step === 5 && (
              <>
                {admissionAttachments.length > 0 && (
                  <>
                    <SectionSeparator title="title.settling_in_policy" />
                    <ul>
                      {admissionAttachments.map((attachment, index) => (
                        <li key={index}>
                          <Button
                            onClick={() =>
                              setAdmissionAttachmentModal({
                                show: true,
                                title: attachment.title,
                                content: attachment.text,
                              })
                            }
                            variant="link"
                          >
                            {attachment.title}
                          </Button>
                        </li>
                      ))}
                    </ul>
                  </>
                )}
                <SectionSeparator title="title.acknowledgement" />
                <Row className="mb-4">
                  <Col md={"auto"}>
                    <Form.Check
                      checked={formData?.check_acknowledgement == 1}
                      type="checkbox"
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          check_acknowledgement: e.target.checked ? 1 : 0,
                        }))
                      }
                    />
                  </Col>
                  <Col>
                    <FormattedMessage id="acknowledgement" />
                  </Col>
                  <SignaturePad
                    signature={signature}
                    setSignature={setSignature}
                    admissionID={formData.admission_id}
                    setFormData={setFormData}
                    error={errors?.signature}
                  />
                </Row>
              </>
            )} */}
          </div>
        </div>
      </div>
      <Modal
        size="xl"
        show={admissionAttachmentModal.show}
        onHide={() =>
          setAdmissionAttachmentModal({
            show: false,
            title: "",
            content: "",
          })
        }
      >
        <Modal.Header closeButton>
          <Modal.Title>{admissionAttachmentModal.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            dangerouslySetInnerHTML={{
              __html: admissionAttachmentModal.content,
            }}
          />
        </Modal.Body>
      </Modal>
      <ToastContainer
        position={
          locale === "en" || locale === "ro" ? "bottom-right" : "bottom-left"
        }
        rtl={locale === "ar"}
        hideProgressBar={true}
        theme="colored"
      />
    </IntlProvider>
  );
};

export default App;
